export default "__VITE_ASSET__DbpPH8X___"